/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetOrder200ResponseData
 */
export interface GetOrder200ResponseData {
  /**
   *
   * @type {number}
   * @memberof GetOrder200ResponseData
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof GetOrder200ResponseData
   */
  userUuid: string
  /**
   *
   * @type {string}
   * @memberof GetOrder200ResponseData
   */
  number: string
  /**
   *
   * @type {number}
   * @memberof GetOrder200ResponseData
   */
  currencyId: number
  /**
   *
   * @type {number}
   * @memberof GetOrder200ResponseData
   */
  price: number
  /**
   *
   * @type {string}
   * @memberof GetOrder200ResponseData
   */
  notes?: string | null
  /**
   *
   * @type {Date}
   * @memberof GetOrder200ResponseData
   */
  dateHoldPrice?: Date | null
  /**
   *
   * @type {number}
   * @memberof GetOrder200ResponseData
   */
  ownerSysObjectId: number
}

/**
 * Check if a given object implements the GetOrder200ResponseData interface.
 */
export function instanceOfGetOrder200ResponseData(
  value: object
): value is GetOrder200ResponseData {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('userUuid' in value) || value['userUuid'] === undefined) return false
  if (!('number' in value) || value['number'] === undefined) return false
  if (!('currencyId' in value) || value['currencyId'] === undefined)
    return false
  if (!('price' in value) || value['price'] === undefined) return false
  if (!('ownerSysObjectId' in value) || value['ownerSysObjectId'] === undefined)
    return false
  return true
}

export function GetOrder200ResponseDataFromJSON(
  json: any
): GetOrder200ResponseData {
  return GetOrder200ResponseDataFromJSONTyped(json, false)
}

export function GetOrder200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOrder200ResponseData {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    userUuid: json['userUuid'],
    number: json['number'],
    currencyId: json['currencyId'],
    price: json['price'],
    notes: json['notes'] == null ? undefined : json['notes'],
    dateHoldPrice:
      json['dateHoldPrice'] == null
        ? undefined
        : new Date(json['dateHoldPrice']),
    ownerSysObjectId: json['ownerSysObjectId'],
  }
}

export function GetOrder200ResponseDataToJSON(
  value?: GetOrder200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    userUuid: value['userUuid'],
    number: value['number'],
    currencyId: value['currencyId'],
    price: value['price'],
    notes: value['notes'],
    dateHoldPrice:
      value['dateHoldPrice'] == null
        ? undefined
        : (value['dateHoldPrice'] as any).toISOString(),
    ownerSysObjectId: value['ownerSysObjectId'],
  }
}
